
import { defineComponent, computed } from "vue";
import { useStore } from "../../stores";
import { AbstractPlayer } from "../../types/abstract-player";
import gameApplication from "../../game/game-app";
import { TournamentMessageEnum } from "../../types/tournament-message-enum";

export default defineComponent({
  name: "GameChat",

  data: () => ({
    message: '',
    edit: false,
  }),

  setup() {
    const store = useStore();
    const room = computed(() => store.state.joinedRoom);
    const playerList = computed(() => store.state.playerList);
    const chatMessages = computed(() => store.state.chatMessages);
    const player = gameApplication.getPlayer().player;

    return { player, room, playerList, chatMessages };
  },

  methods: {
    
    onEnter(): void {
      if (this.message !== '') {
        this.send();
      }
    },

    send(): void {
      gameApplication.sendChatMessage(this.message);
      this.message = '';
    },

    onInvitePlayer(abstractPlayer: AbstractPlayer): void {
      this.$emit('selectOpponent', abstractPlayer);
    },

    /** 
     * Remove player duplicates for saftey.
     * FIXME: this is incorrecty coded 
     */
    getPlayerListWitoutDuplicates(): void {
      this.playerList.filter((v, i, a) => a.indexOf(v) === i);
    },

    /**
     * This is executed when the player clicks on the tournament link.
     */
    handleClick(evt: PointerEvent) {
      const target: EventTarget = evt.target;
      const htmlTarget = (<HTMLInputElement>target);

      if (htmlTarget.hasAttribute('data-tournamentid')) {
        const tournamentId: string = htmlTarget.getAttribute('data-tournamentid');
        this.actionPerformed(tournamentId);
      }
    },

    actionPerformed(tournamentId: string): void {
      if (gameApplication.getPlayer().player.guest) {
        gameApplication.tournamentStatus(TournamentMessageEnum.NOT_REGISTERED);
      } else if (gameApplication.selectedRoom.roomId === tournamentId) {
        gameApplication.tournamentStatus(TournamentMessageEnum.ALREADY_JOINED);
      } else {
        gameApplication.sendSignupTournament(tournamentId);
      }
    },

    getPlayerRank(player: AbstractPlayer): string {
      if (player.guest === undefined) {
        if (player.playerId.startsWith('guest')) {
          return 'Guest Player';
        } else {
          return 'Not Available';
        }
      } else if (player.guest === 'true') {
        return 'Guest Player';
      } else if (player.guest === 'false') {
        return this.getRank(player.rank);
      }
    },

    getRank(points: number): string {
      if (points >= 1000) {
        return 'Master';
      }
      else if (points >= 900) {
        return 'Proessional';
      }
      else if (points >= 800) {
        return 'Expert';
      }
      else if (points >= 600) {
        return 'Intermediate';
      }
      else if (points >= 400) {
        return 'Rising Star';
      }
      else if (points >= 200) {
        return 'Rising Star';
      }
      else if (points >= 100) {
        return "Amature";
      }
      else if (points < 100) {
        return 'Beginner';
      } else {
        return 'Unknown';
      }
    },
  },

  components: {},
});
